import { Link } from "@tanstack/react-router"
import { LockIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import DebtTableImage from "@/svg/home/debt-table.svg?react"

type DebtTableCardProps = {
  disabled: boolean
}

export default function DebtTableCard({ disabled }: DebtTableCardProps) {
  return (
    <Card className="@container min-w-0 overflow-hidden p-6">
      <div className="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-4 @lg:grid-cols-[auto_1fr]">
        <DebtTableImage className="pointer-events-none row-span-2 hidden h-full w-full @lg:block" />
        <CardTitle>Debt Overview</CardTitle>

        <div className="flex min-w-0 flex-col justify-between">
          <p className="mb-4">
            An organized summary of current debts, payments, and due dates.
          </p>
          {disabled ? (
            <Button disabled className="bg-primary self-start">
              See Summary
              <LockIcon className="ml-2 h-4 w-4" />
            </Button>
          ) : (
            <Button className="bg-primary self-start" asChild>
              <Link to="/debt-table">See Summary</Link>
            </Button>
          )}
        </div>
      </div>
    </Card>
  )
}
